<template>
  <el-dialog
    v-if="!$device.mobile"
    :visible.sync="show"
    append-to-body
    v-bind="$attrs"
    :class="{
      'shake-dialog': shakeDialog
    }"
    v-on="$listeners"
  >
    <template v-if="title" #title>
      <slot name="title">
        <div class="title">
          {{ title }}
        </div>
      </slot>
    </template>
    <template>
      <slot></slot>
    </template>
    <template #footer>
      <slot name="footer"></slot>
    </template>
  </el-dialog>
  <m-drawer v-else :title="title" :show.sync="show" v-bind="$attrs" v-on="$listeners">
    <template #content>
      <slot></slot>
    </template>
    <template #footer>
      <slot name="footer"></slot>
    </template>
  </m-drawer>
</template>

<script>
import mDrawer from '../mobile/base/m-drawer.vue'
export default {
  name: 'DialogComponent',
  components: {
    mDrawer
  },
  props: {
    visible: Boolean,
    title: {
      type: String,
      default: ''
    },
    shakeDialog: Boolean
  },
  computed: {
    show: {
      get() {
        return this.visible
      },
      set(v) {
        this.$emit('update:visible', v)
      }
    }
  }
}
</script>

<style scoped>
.title {
  font-family: theme('fontFamily.pingFang');
  font-size: 24px;
  font-weight: 500;
  color: theme('colors.text.regular');
}

.secondary-title {
  font-family: theme('fontFamily.pingFang');
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: theme('colors.text.secondary');
}
</style>
